import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style';

export default class Preloader extends Component {

  constructor(props) {
    super(props);
    this.getPreloader = this.getPreloader.bind(this);
  }

  getPreloader() {
    if (this.props.size) {
      style.preloader.fontSize = this.props.size;
    }

    switch (this.props.type) {
      case 'spinner':
        return (<i className="fa fa-spinner fa-spin fa-3x fa-fw" style={style.preloader}></i>);
        break;
      case 'circle':
        return (<i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={style.preloader}></i>);
        break;
      case 'refresh':
        return (<i className="fa fa-refresh fa-spin fa-3x fa-fw" style={style.preloader}></i>);
        break;
      case 'cog':
        return (<i claclassNamess="fa fa-cog fa-spin fa-3x fa-fw" style={style.preloader}></i>);
        break;
      case 'spinner-pulse':
        return (<i className="fa fa-spinner fa-pulse fa-3x fa-fw" style={style.preloader}></i>);
        break;
      default:

    }
  }

  render() {
    if (!this.props.show) {
      return null;
    }

    if (this.props.padding) {
      style.container.padding = this.props.padding;
    }

    return (
      <div className="preloader" style={style.container}>
        {this.getPreloader()}
      </div>
    );
  }
}

Preloader.propTypes = {
  show: PropTypes.bool,
  type: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/Preloader/index.js